import { useEffect, useState } from 'react';
import { User } from '@supabase/supabase-js';
import { supabase } from '@/integrations/supabase/client';

export type Profile = {
  first_name: string | null;
  last_name: string | null;
  age: number | null;
};

export function useAuthAndProfile() {
  const [user, setUser] = useState<User | null>(null);
  const [profile, setProfile] = useState<Profile | null>(null);
  const [loading, setLoading] = useState(true);

  async function load() {
    try {
      const { data: { user: currentUser } } = await supabase.auth.getUser();
      setUser(currentUser ?? null);
      
      if (currentUser) {
        const { data } = await supabase
          .from('profiles')
          .select('first_name, last_name, age')
          .eq('user_id', currentUser.id)
          .maybeSingle();
        
        setProfile(data ?? { first_name: null, last_name: null, age: null });
      } else {
        setProfile(null);
      }
    } catch (error) {
      console.error('Error loading profile:', error);
      setProfile(null);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
    
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event) => {
      // Use setTimeout to prevent blocking auth state changes
      setTimeout(() => {
        load();
      }, 0);
    });

    return () => subscription.unsubscribe();
  }, []);

  return { user, profile, loading, reload: load };
}